import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AcaoComercial } from "../model/acao-comercial.model";

@Injectable()
export class AcaoComercialService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Ação de Relacionamento por id
     * @param id ID da Ação de Relacionamento
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "acao-comercial/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Ação de Relacionamento
     * @param id ID da Ação de Relacionamento
     */
    getAll(params: any): Observable<ApiPaginationResponseDataNonNullable<AcaoComercial>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        const env = paramHttp ? `?${paramHttp}` : "";

        return this._http.get<ApiPaginationResponseDataNonNullable<AcaoComercial>>(
            this.utilitesService.urlPrefix + "acao-comercial" + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * PROSP-648 (Fase 2 / C3): monitor de reconciliação por planejamento.
     * Consome GET acao-comercial-planejamento/info-reconciliacao (paginado).
     * @param params filtros: status, page, per_page
     */
    getReconciliacao(params: any): Observable<ApiPaginationResponseDataNonNullable<any>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        const env = paramHttp ? `?${paramHttp}` : "";

        return this._http.get<ApiPaginationResponseDataNonNullable<any>>(
            this.utilitesService.urlPrefix + "acao-comercial-planejamento/info-reconciliacao" + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Lista de Ação de Relacionamento
     */
    getAllAssuntos(params: any): Observable<ApiPaginationResponseDataNonNullable<AcaoComercial>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        const env = paramHttp ? `?${paramHttp}` : "";

        return this._http.get<ApiPaginationResponseDataNonNullable<AcaoComercial>>(
            this.utilitesService.urlPrefix + "acao-comercial/assuntos" + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Lista de Ativo Para Campo Do Cadastro de Cliente
     */
    getLista(): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "acao-comercial/lista", {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de Ação de Relacionamento
     * @param id ID da Ação de Relacionamento
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "acao-comercial/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Ação de Relacionamento
     * @param params Json Ação de Relacionamento
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "acao-comercial", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza Ação de Relacionamento
     * @param params Json Ação de Relacionamento
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(this.utilitesService.urlPrefix + "acao-comercial/" + id, JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }
}
